/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { InternalAdminWhitelabelRequestV4ToJSON, InternalAdminWhitelabelResponseV4FromJSON, ListNetworkWhitelabels200ResponseFromJSON, } from '../models/index';
/**
 *
 */
export class AdminApi extends runtime.BaseAPI {
    /**
     * Creates a new whitelabel configuration for network donations. Requires the donations whitelabel feature to be enabled for the network.
     * Create network donations whitelabel
     */
    createDonationsWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['internalAdminWhitelabelRequestV4'] == null) {
                throw new runtime.RequiredError('internalAdminWhitelabelRequestV4', 'Required parameter "internalAdminWhitelabelRequestV4" was null or undefined when calling createDonationsWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/admin/v4/donations/whitelabels`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InternalAdminWhitelabelRequestV4ToJSON(requestParameters['internalAdminWhitelabelRequestV4']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAdminWhitelabelResponseV4FromJSON(jsonValue));
        });
    }
    /**
     * Creates a new whitelabel configuration for network donations. Requires the donations whitelabel feature to be enabled for the network.
     * Create network donations whitelabel
     */
    createDonationsWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createDonationsWhitelabelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates a new whitelabel configuration for a network. Requires the white label URL feature to be enabled for the network.
     * Create network whitelabel
     */
    createNetworkWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['internalAdminWhitelabelRequestV4'] == null) {
                throw new runtime.RequiredError('internalAdminWhitelabelRequestV4', 'Required parameter "internalAdminWhitelabelRequestV4" was null or undefined when calling createNetworkWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/admin/v4/whitelabels`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InternalAdminWhitelabelRequestV4ToJSON(requestParameters['internalAdminWhitelabelRequestV4']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAdminWhitelabelResponseV4FromJSON(jsonValue));
        });
    }
    /**
     * Creates a new whitelabel configuration for a network. Requires the white label URL feature to be enabled for the network.
     * Create network whitelabel
     */
    createNetworkWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createNetworkWhitelabelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates a new whitelabel configuration for a specific topic
     * Create topic whitelabel
     */
    createTopicWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['topicId'] == null) {
                throw new runtime.RequiredError('topicId', 'Required parameter "topicId" was null or undefined when calling createTopicWhitelabel().');
            }
            if (requestParameters['internalAdminWhitelabelRequestV4'] == null) {
                throw new runtime.RequiredError('internalAdminWhitelabelRequestV4', 'Required parameter "internalAdminWhitelabelRequestV4" was null or undefined when calling createTopicWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/admin/v4/topics/{topic_id}/whitelabels`;
            urlPath = urlPath.replace(`{${"topic_id"}}`, encodeURIComponent(String(requestParameters['topicId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InternalAdminWhitelabelRequestV4ToJSON(requestParameters['internalAdminWhitelabelRequestV4']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAdminWhitelabelResponseV4FromJSON(jsonValue));
        });
    }
    /**
     * Creates a new whitelabel configuration for a specific topic
     * Create topic whitelabel
     */
    createTopicWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createTopicWhitelabelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes an existing whitelabel configuration for network donations. Requires admin authorization for validated whitelabels and the donations whitelabel feature to be enabled for the network.
     * Delete network donations whitelabel
     */
    deleteDonationsWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteDonationsWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/donations/whitelabels/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes an existing whitelabel configuration for network donations. Requires admin authorization for validated whitelabels and the donations whitelabel feature to be enabled for the network.
     * Delete network donations whitelabel
     */
    deleteDonationsWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteDonationsWhitelabelRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Deletes an existing whitelabel configuration for a network. Requires admin authorization for validated whitelabels and the white label URL feature to be enabled for the network.
     * Delete network whitelabel
     */
    deleteNetworkWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteNetworkWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/whitelabels/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes an existing whitelabel configuration for a network. Requires admin authorization for validated whitelabels and the white label URL feature to be enabled for the network.
     * Delete network whitelabel
     */
    deleteNetworkWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteNetworkWhitelabelRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Deletes an existing whitelabel configuration for a specific topic. Requires admin authorization for validated whitelabels.
     * Delete topic whitelabel
     */
    deleteTopicWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['topicId'] == null) {
                throw new runtime.RequiredError('topicId', 'Required parameter "topicId" was null or undefined when calling deleteTopicWhitelabel().');
            }
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteTopicWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/topics/{topic_id}/whitelabels/{id}`;
            urlPath = urlPath.replace(`{${"topic_id"}}`, encodeURIComponent(String(requestParameters['topicId'])));
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes an existing whitelabel configuration for a specific topic. Requires admin authorization for validated whitelabels.
     * Delete topic whitelabel
     */
    deleteTopicWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteTopicWhitelabelRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Retrieves whitelabel configurations for network donations. Requires the donations whitelabel feature to be enabled for the network.
     * List network donations whitelabels
     */
    listDonationsWhitelabelsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/donations/whitelabels`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListNetworkWhitelabels200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves whitelabel configurations for network donations. Requires the donations whitelabel feature to be enabled for the network.
     * List network donations whitelabels
     */
    listDonationsWhitelabels(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listDonationsWhitelabelsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Retrieves whitelabel configurations for a network. Requires the white label URL feature to be enabled for the network.
     * List network whitelabels
     */
    listNetworkWhitelabelsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/whitelabels`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListNetworkWhitelabels200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves whitelabel configurations for a network. Requires the white label URL feature to be enabled for the network.
     * List network whitelabels
     */
    listNetworkWhitelabels(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listNetworkWhitelabelsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Retrieves whitelabel configurations for a specific topic
     * List topic whitelabels
     */
    listTopicWhitelabelsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['topicId'] == null) {
                throw new runtime.RequiredError('topicId', 'Required parameter "topicId" was null or undefined when calling listTopicWhitelabels().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/topics/{topic_id}/whitelabels`;
            urlPath = urlPath.replace(`{${"topic_id"}}`, encodeURIComponent(String(requestParameters['topicId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ListNetworkWhitelabels200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieves whitelabel configurations for a specific topic
     * List topic whitelabels
     */
    listTopicWhitelabels(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listTopicWhitelabelsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates an existing whitelabel configuration for network donations. Requires the donations whitelabel feature to be enabled for the network.
     * Update network donations whitelabel
     */
    updateDonationsWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateDonationsWhitelabel().');
            }
            if (requestParameters['internalAdminWhitelabelRequestV4'] == null) {
                throw new runtime.RequiredError('internalAdminWhitelabelRequestV4', 'Required parameter "internalAdminWhitelabelRequestV4" was null or undefined when calling updateDonationsWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/admin/v4/donations/whitelabels/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: InternalAdminWhitelabelRequestV4ToJSON(requestParameters['internalAdminWhitelabelRequestV4']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAdminWhitelabelResponseV4FromJSON(jsonValue));
        });
    }
    /**
     * Updates an existing whitelabel configuration for network donations. Requires the donations whitelabel feature to be enabled for the network.
     * Update network donations whitelabel
     */
    updateDonationsWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateDonationsWhitelabelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates an existing whitelabel configuration for a network. Requires the white label URL feature to be enabled for the network.
     * Update network whitelabel
     */
    updateNetworkWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateNetworkWhitelabel().');
            }
            if (requestParameters['internalAdminWhitelabelRequestV4'] == null) {
                throw new runtime.RequiredError('internalAdminWhitelabelRequestV4', 'Required parameter "internalAdminWhitelabelRequestV4" was null or undefined when calling updateNetworkWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/admin/v4/whitelabels/{id}`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: InternalAdminWhitelabelRequestV4ToJSON(requestParameters['internalAdminWhitelabelRequestV4']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAdminWhitelabelResponseV4FromJSON(jsonValue));
        });
    }
    /**
     * Updates an existing whitelabel configuration for a network. Requires the white label URL feature to be enabled for the network.
     * Update network whitelabel
     */
    updateNetworkWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateNetworkWhitelabelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates an existing whitelabel configuration for a specific topic
     * Update topic whitelabel
     */
    updateTopicWhitelabelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['topicId'] == null) {
                throw new runtime.RequiredError('topicId', 'Required parameter "topicId" was null or undefined when calling updateTopicWhitelabel().');
            }
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateTopicWhitelabel().');
            }
            if (requestParameters['internalAdminWhitelabelRequestV4'] == null) {
                throw new runtime.RequiredError('internalAdminWhitelabelRequestV4', 'Required parameter "internalAdminWhitelabelRequestV4" was null or undefined when calling updateTopicWhitelabel().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/internal/admin/v4/topics/{topic_id}/whitelabels/{id}`;
            urlPath = urlPath.replace(`{${"topic_id"}}`, encodeURIComponent(String(requestParameters['topicId'])));
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: InternalAdminWhitelabelRequestV4ToJSON(requestParameters['internalAdminWhitelabelRequestV4']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAdminWhitelabelResponseV4FromJSON(jsonValue));
        });
    }
    /**
     * Updates an existing whitelabel configuration for a specific topic
     * Update topic whitelabel
     */
    updateTopicWhitelabel(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateTopicWhitelabelRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Validates the DNS configuration for a specific network donations whitelabel. Requires the donations whitelabel feature to be enabled for the network.
     * Validate network donations whitelabel DNS
     */
    validateDonationsWhitelabelDNSRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling validateDonationsWhitelabelDNS().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/donations/whitelabels/{id}/validate`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Validates the DNS configuration for a specific network donations whitelabel. Requires the donations whitelabel feature to be enabled for the network.
     * Validate network donations whitelabel DNS
     */
    validateDonationsWhitelabelDNS(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateDonationsWhitelabelDNSRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Validates the DNS configuration for a specific network whitelabel. Requires the white label URL feature to be enabled for the network.
     * Validate network whitelabel DNS
     */
    validateNetworkWhitelabelDNSRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling validateNetworkWhitelabelDNS().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/whitelabels/{id}/validate`;
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Validates the DNS configuration for a specific network whitelabel. Requires the white label URL feature to be enabled for the network.
     * Validate network whitelabel DNS
     */
    validateNetworkWhitelabelDNS(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateNetworkWhitelabelDNSRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Validates the DNS configuration for a specific topic whitelabel
     * Validate topic whitelabel DNS
     */
    validateTopicWhitelabelDNSRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['topicId'] == null) {
                throw new runtime.RequiredError('topicId', 'Required parameter "topicId" was null or undefined when calling validateTopicWhitelabelDNS().');
            }
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling validateTopicWhitelabelDNS().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/admin/v4/topics/{topic_id}/whitelabels/{id}/validate`;
            urlPath = urlPath.replace(`{${"topic_id"}}`, encodeURIComponent(String(requestParameters['topicId'])));
            urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Validates the DNS configuration for a specific topic whitelabel
     * Validate topic whitelabel DNS
     */
    validateTopicWhitelabelDNS(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateTopicWhitelabelDNSRaw(requestParameters, initOverrides);
        });
    }
}
